import React from "react";

/**
 * @typedef {Object} ContextValue
 * @property {Object} data - The data from the backend.
 * @property {Object} feedback - The feedback from the backend.
 * @property {function} updateUserData - Function to update user data.
 * @property {function} reload - Function to reload the context.
 */
const AppContext = React.createContext({});

export default AppContext;
